import { ChangeEvent, HTMLInputTypeAttribute, MouseEvent, useState } from "react"
import ShowPasswordIcon from '../../assets/eye.svg';
import HidePasswordIcon from '../../assets/eye-off.svg';

export default function InputField({
    label,
    type,
    id,
    name,
    value,
    isRequired,
    handleChange,
    placeholder,
    index,
    disabled,
}: {
    label?: string,
    type: HTMLInputTypeAttribute | 'textarea',
    id: string,
    name: string,
    value: string | number,
    isRequired: boolean,
    handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index?: number) => void,
    placeholder?: string;
    index?: number,
    disabled?: boolean,
}) {

    const [ isPWShown, setIsPWShown ] = useState(false);

    const togglePW = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsPWShown(!isPWShown);
    }

    return (
        <div className="w-full flex flex-col justify-center items-start gap-2 text-default">
            {label !== undefined && <label htmlFor={id} className={`text-[12px] font-medium ${isRequired && 'required'}`}>{label}</label>}
            {type === 'password' ? (
                <div className="rounded-lg border border-outline focus-within:border-primary w-full flex justify-between items-stretch overflow-hidden">
                    <input disabled={disabled} onChange={(e:any) => handleChange(e, index)} id={id} type={isPWShown ? 'text' : 'password'} name={name} value={value} placeholder={placeholder ? placeholder : label} className="px-4 py-3 grow focus:outline-none"/>
                    <button onClick={togglePW} type='button' className="pr-4 flex justify-center items-center">
                        {isPWShown ? <img src={HidePasswordIcon} alt='hide-pw-icon' className="w-[24px]"/> : <img src={ShowPasswordIcon} alt='show-pw-icon' className="w-[24px]"/>}
                    </button>
                </div>
            ) : type === 'textarea' ? (
                <textarea disabled={disabled} rows={3} onChange={(e:any) => handleChange(e, index)} id={id} required={isRequired} name={name} value={value} placeholder={placeholder ? placeholder : label} className="px-4 py-3 rounded-lg border border-outline focus:border-primary focus:outline-none w-full"/>
            ) : (
                <input disabled={disabled} onChange={(e:any) => handleChange(e, index)} id={id} required={isRequired} type={type} name={name} value={value} placeholder={placeholder ? placeholder : label} className="px-4 py-3 rounded-lg border border-outline focus:border-primary focus:outline-none w-full"/>
            )}
        </div>
    )
}